module.exports = require("express-session");


//////////////////
// WEBPACK FOOTER
// external "express-session"
// module id = 41
// module chunks = 0